<div [ngClass]="deviceType()" class="section_3dsourcecom">
  <router-outlet />
  <div
    class="configurator_3dsourcecom_section_overlay"
    appMyCdkOverlayContainer
  ></div>
  <app-global-loading />

  @if (!IS_EMBED_LINK) {
  <app-network-status />
  }
  <div aria-live="polite" toastContainer></div>
</div>
